import { Select, Option, Autocomplete, DatePicker, Button } from "element-ui";
import InputBase from "@/components/Additional/InputBase";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import dayjs from "dayjs";


import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    employeeId: "",
    password: "",
    tabAttendance: 1,
    selects: {
      absentReason: "",
      absentDescription: ""
    },
    optionDescription: [
      {
        value: "Liburan =D",
        label: "Liburan =D"
      },
      {
        value: "Bulan  Madu :)",
        label: "Bulan  Madu :)"
      },
      {
        value: "Other",
        label: "Other"
      }
    ],
    otherAbsentReason: "",
    startDate: "",
    endDate: "",
    password: "",
    fileName: "",
    fileSave: "",
    isLoading: false
  }),
  components: {
    InputBase,
    VueCtkDateTimePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters("attendance", ["optionReason", "optionAbsentDescription"]),
    hideOtherAbsentReason() {
      if (this.selects.absentDescription === "Other") {
        return true
      } else {
        return false
      }
    },
    limitDateTime() {
      const newDate = () => {
        if (this.startDate) {
          const newDate = new Date(this.startDate).getTime() + 60 * 1000;
          return dayjs(newDate).format("YYYY-MM-DD HH:mm");
        }
      };
      return newDate();
    },
    limitStartDate() {
      const newDate = () => {
        const newDate = new Date().getTime() + 60 * 1000;
        return dayjs(newDate).format("YYYY-MM-DD HH:mm");
      };
      return newDate();
    }
  },
  methods: {
    ...mapActions("attendance", ["requestAbsent", "getListReasons", "getAbsentDescription"]),
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type
      });
    },
    async submitAttendace() {
      try {
        this.isLoading = true;
        const startDateNum = new Date(this.startDate).getTime();
        const endDateNum = new Date(this.endDate).getTime();
        if (!this.employeeId) throw "ID Karyawan harus diisi";
        if (!this.selects.absentReason) throw "Alasan absent harus dipilih";
        if (this.selects.absentDescription === "Other") {
          if (!this.otherAbsentReason) throw "Rincian absent other harus diisi";
        } else {
          if (!this.selects.absentDescription) throw "Rincian absent harus dipilih";
        }
        if (!this.startDate) throw "Tanggal mulai harus diisi";
        if (!this.endDate) throw "Tanggal berakhir harus diisi";
        if (!this.fileSave) throw "Unggah foto tidak boleh kosong";
        if (!this.password) throw "Kata sandi harus diisi";
        if (startDateNum >= endDateNum) throw "Tanggal mulai harus lebih dahulu dari tanggal berakhir";
        const requestForm = new FormData();
        const request = {
          employeeId: this.employeeId,
          password: this.password,
          absentReasonId: this.selects.absentReason,
          absentDescription: this.selects.absentDescription === "Other" ? this.otherAbsentReason : this.selects.absentDescription,
          timestampStart: this.startDate,
          timestampEnd: this.endDate,
          file: this.fileSave,
        }

        for (const [key, value] of Object.entries(request)) {
          requestForm.append(key, value);
        }
        await this.requestAbsent(requestForm);
        this.notifyVue("success", "Request absent success");
        this.isLoading = false;
        this.$router.push("/auth/login");
      } catch (err) {
        this.isLoading = false;
        if (err?.response?.status === 401) {
          this.notifyVue("danger", err.response.data.error);
        } else if (err?.response?.status === 400) {
          this.notifyVue("danger", err.response.data.error);
        } else {
          this.notifyVue("danger", err);
        }
      }
    },
    changeInputUpload() {
      const el = this.$refs.uploadPhoto;
      el.click();
    },
    selectPhoto(e) {
      this.fileName = e.target.files[0].name;
      this.fileSave = e.target.files[0]
    },

  },
  created() {
    const getAllOption = async () => {
      await this.getListReasons();
      await this.getAbsentDescription();
    }
    getAllOption();
  }
};
